import * as React from 'react';
import { ProductInterface } from '../../../Model/Product';
import { AbstractRow } from '../AbstractRow';
import { AttributeCell } from '../AttributeCell';
import { FinderImage } from '../FinderImage';
import { HeadlineCell } from '../HeadlineCell';
import { MiscCell } from '../MiscCell';
import { WatchlistCell } from '../WatchlistCell';

export class WebGuideControllerRow extends AbstractRow {
    public renderCells() {
        const product = this.props.product;

        return <>
            <td><FinderImage product={product} attr="A_PIM_Bild_Basisartikel"/></td>
            <AttributeCell product={product} attr="Beschreibung_Basisartikel_kurz"/>
            <AttributeCell product={product} attr="@parent.Feldbus"/>
            <AttributeCell product={product} attr="Funktionen"/>
            <AttributeCell product={product} attr="Schutzart"/>
            <MiscCell product={product} datasheetAttr="@parent.Datenblatt" manualAttr="@parent.Bedienungsanleitung"/>
        </>;
    }

    protected renderHeadline(product: ProductInterface): JSX.Element {
        return <>
            <HeadlineCell colSpan={5} product={product} attr="name"/>
            <WatchlistCell product={product}/>
        </>;
    }
}
